import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Wrapper, dropdownStyle } from './styled';
import { ThemeContext } from 'Context';
import { optionsSortByWs, sortByWs } from 'Screens/Constants';
import Dropdown from 'Common/Kit/select';
import { setOrderByWorkspaces } from '../../actions/Actions';
import { selectOrderSaved } from 'store/Preferences/workspace/selectors';

const SortBy = () => {
  const { themeStyles } = useContext(ThemeContext);
  const dispatch = useDispatch();
  const orderBy = useSelector(selectOrderSaved);
  const getOrderBy = () => {
    if (orderBy) return { field: orderBy.field, direction: orderBy.direction === 'asc' };
    else return { field: 'update_date', direction: true };
  };
  const orderBySelected = getOrderBy();
  const orderByParsed = orderBySelected?.field;

  const filteredOptions = optionsSortByWs.filter((opt) => opt.value !== orderByParsed);

  return (
    <Wrapper>
      <Dropdown
        style={ dropdownStyle(themeStyles) }
        placeholder="Sort By"
        options={ filteredOptions }
        onChange={ (el) => dispatch(setOrderByWorkspaces([sortByWs[el?.value]])) }
        defaultValue={ optionsSortByWs.find((option) => option.value === orderByParsed) }
        isSearchable={ false }
      />
    </Wrapper>
  );
};

export default SortBy;
